import { Chip } from "$components/chip";
import React from "react";

interface Props {
  difference: number;
}

export const DifferenceChip: React.FunctionComponent<Props> = ({
  difference,
}) => {
  let chipProps: React.ComponentProps<typeof Chip>;
  if (difference === 0) {
    chipProps = { color: "disabled", label: `${difference}` };
  } else if (difference > 0) {
    chipProps = { color: "brand", label: `+ ${difference}` };
  } else {
    chipProps = { color: "pink", label: `- ${Math.abs(difference)}` };
  }

  return <Chip {...chipProps} />;
};
